module.exports = __webpack_public_path__ + "static/media/small.7cd55d89.svg";